import React from "react";
import { useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";

import { SectionIds } from "@constants/sectionIds";
import InfoCard from "@components/common/InfoCard/InfoCard";

import useSystemAdvantagesData from "./useSystemAdvantagesData";

import "./SystemAdvantages.scss";

const SystemAdvantages = () => {
  const { t } = useTranslation(["landingPage"]);
  const data = useSystemAdvantagesData();

  const { ref } = useParallax({
    speed: 15,
    scale: [1.05, 1, "easeOutCubic"]
  });

  return (
    <section id={SectionIds.SystemAdvantages} className="system-advantages">
      <img
        ref={ref as any}
        src="/images/layouts/bubble-paralax.png"
        alt="background paralax"
        className="system-advantages-paralax"
      />

      <div className="system-advantages-main">
        <h2>{t("landingPage:systemAdvantages.title")}</h2>
        <p className="p0 mt-8 description">{t("landingPage:systemAdvantages.description")}</p>

        <div className="advantages-cards">
          {data.map(({ img, description }, index) => (
            <InfoCard key={index} imgSrc={img.src} imgAlt={img.alt} description={description} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemAdvantages;
